import { inject, injectable, injectFromBase } from 'inversify'
import ExternalTrackerService from '@/services/tracking/externalTrackerService'
// eslint-disable-next-line tp/forbid-import-composable-to-service,tp/using-vue-in-services-restriction
import type { Plugin } from '@/composition/vue/compositionApi'
import type { ExternalTrackerAsPlugin, TrackableConfig } from '@/services/tracking/types'
import type { MonitoringLoggerService } from '@/services/monitoring/monitoringLoggerService'
import { LogLevel } from '@/core/logger/types'
import { SERVICE_TYPES } from '@/core/container/types'

@injectable()
@injectFromBase()
export class MicrosoftUetService extends ExternalTrackerService {
  private trackingId = '56283065'

  constructor(
    @inject(SERVICE_TYPES.MonitoringLoggerService) protected readonly monitoringLoggerService: MonitoringLoggerService,
  ) {
    super()
  }

  public getConfig(): TrackableConfig {
    return {
      id: this.trackingId,
    }
  }

  public getPlugin(): Plugin {
    return {
      install: () => this.initialize(),
    } satisfies Plugin
  }

  protected async initialize(): Promise<void> {
    const trackingId = this.trackingId
    const logAndCaptureError = (e: string | Error) => {
      this.monitoringLoggerService.logAndCapture(e, LogLevel.ERROR)
    }
    /* eslint-disable */
    /* prettier-ignore */
    const trackingHandler = async () => {
      ;(function (w, d, t, r, u) {
        var f, n, i
        ;(w[u] = w[u] || []),
          (f = function () {
            var o = { ti: trackingId, enableAutoSpaTracking: true }
            // @ts-expect-error window conversion object assignment
            ;(o.q = w[u]), (w[u] = new UET(o)), w[u].push('pageLoad')
          }),
          (n = d.createElement(t)),
          (n.src = r),
          (n.async = 1),
          (n.onload = n.onreadystatechange =
            function () {
              var s = this.readyState
              if (s && s !== 'loaded' && s !== 'complete') return
              n.onload = n.onreadystatechange = null
              var attempts = 0
              var tryInit = function () {
                // @ts-expect-error looking for a global object
                if (typeof UET !== 'undefined') {
                  f()
                } else if (attempts < 10) {
                  attempts++
                  setTimeout(tryInit, 200)
                } else {
                  logAndCaptureError('Microsoft UET: failed to initialize after 10 attempts')
                }
              }
              tryInit()
            }),
          (i = d.getElementsByTagName(t)[0]),
          i.parentNode.insertBefore(n, i)
      })(window, document, 'script', '//bat.bing.com/bat.js', 'uetq')
    }
    /* eslint-enable */
    const trackerAsPlugin: ExternalTrackerAsPlugin = {
      trackingHandler,
      loadOnCustomEvent: true,
    }
    this.initializeTrackerAsPlugin(trackerAsPlugin)
  }
}
